import fetchRetry from "../utils/fetchRetry";
import { getPuPlayerProgressUrl } from "../utils/urlUtils";

type UserVersionResponse = {
    user_version: string;
    max_allowed_user_version: string;
}

const getUserVersion = async (authToken: string): Promise<UserVersionResponse> => {
    const ppUrl = getPuPlayerProgressUrl()

    if (!ppUrl) {
        throw new Error("Missing player progress url");
    }

    var getUserVersionUrl =  `${ppUrl}/playerprogress/gameversion`

    const headers = new Headers();
    headers.append("Authorization", authToken);
    var myInit = {
        method: "GET",
        headers: headers
    };

    const resp = await fetchRetry(getUserVersionUrl, myInit);

    if(resp.status === 200) {
        return resp.json();
    }

    throw new Error("Failed to load user version");
}

const postMigrateUserVersion = async (targetVersion: string, authToken: string): Promise<UserVersionResponse> => {
    const ppUrl = getPuPlayerProgressUrl()

    if (!ppUrl) {
        throw new Error("Missing player progress url");
    }

    var postMigrateUserVersionUrl =  `${ppUrl}/playerprogress/gameversion/migration`

    const headers = new Headers();
    headers.append("Authorization", authToken);
    var myInit = {
        method: "POST",
        headers: headers,
        body: JSON.stringify({target_version: targetVersion})
    };

    const resp = await fetchRetry(postMigrateUserVersionUrl, myInit);

    if(resp.status === 200) {
        return resp.json();
    }

    throw new Error("Failed to migrate user version");
}

export const resolveUserVersion = async (authToken: string): Promise<string> => {
    const userVersionResp = await getUserVersion(authToken);

    if(userVersionResp.user_version === userVersionResp.max_allowed_user_version) {
        return userVersionResp.user_version;
    }

    const migrationResult = await postMigrateUserVersion(userVersionResp.max_allowed_user_version, authToken);

    return migrationResult.user_version;
}
